// 安心安全メールのトップページ

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import Footer from '../components/Footer';
/*-------------------
    画像のimport
---------------------*/
import iconRegister from '../images/safety/icon_register.svg';
import iconUnsub from '../images/safety/icon_unsubscribe.svg';
import iconHistory from '../images/safety/icon_history.svg';
import iconFaq from '../images/safety/icon_faq.svg';
/*-------------------
    cssのimport
---------------------*/
import '../css/safety.css';

// クラス名
class SafetyTop extends Component {
  constructor(props) {
    super(props);

    // URLから安心安全メールのコードを取得。
    const url = props.location.pathname;
    const num = url.lastIndexOf('/');
    const cryptUrl = url.slice(num + 1);
    this.state = { cryptUrl };
  }

  componentDidMount = async () => {
    const { cryptUrl = '' } = this.state;

    const resData = await commons.siteSetting(cryptUrl);
    const { setting, footer } = resData;

    if (setting === true) return;
    if (setting.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    const { site_info: siteInfo, lcl_gov: lclGov } = setting[0];
    const { lg_cd: lgCd = '' } = lclGov;
    const { top_msg: topMsg = '', name: siteName = '' } = siteInfo;

    // アカウント情報を取得する。
    const accountSetting = await commons.commonSetting({
      lgCd,
      enable: true,
      colName: 'M_ACCOUNT',
      kind: '2',
    });
    const { account_info: accountInfo } = accountSetting[0];
    const { host_name: hostName } = accountInfo;

    document.title = `${siteName}`;

    this.setState({
      footer,
      //   dispNumUser,
      topMsg: commons.shapedContents(topMsg),
      siteName,
      hostName,
    });
  };

  onClickBtnMove = (path) => {
    const { cryptUrl } = this.state;
    const { history } = this.props;
    history.push({ pathname: `${path}/${cryptUrl}` });
  };

  render() {
    const { siteName, topMsg, hostName, footer = '' } = this.state;

    if (footer === '') return true;

    const kochira = (
      <button
        type="button"
        className="btnAtag"
        onClick={() => {
          this.onClickBtnMove('../howto');
        }}
      >
        こちら
      </button>
    );

    return (
      <div id="safety-container">
        <div className="safety-back">
          <div className="safety-title">{siteName}</div>

          <div className="safety-content">
            <div className="safety-top">{topMsg}</div>

            <div className="safety-exposition">
              <h2 className="mt20">
                <button
                  type="button"
                  className="btnAtag"
                  onClick={() => {
                    this.onClickBtnMove('../rule');
                  }}
                >
                  ご利用前に必ずお読みください
                </button>
              </h2>
              <div className="grid-sections">
                <section className="mt20">
                  <h2>
                    {`${siteName}へのご登録`}
                    <img src={iconRegister} alt="登録アイコン" className="icon-right" />
                  </h2>
                  <p>
                    ボタンをクリックすると、メールソフトが起動します。
                    <br />
                    空メールを送信して登録してください。 詳しくは{kochira}を参照してください。
                  </p>
                  <p className="txtSmall">
                    メールソフトが起動しない場合やWebメールをご利用の場合は、
                    <br />
                    <a href={`mailto:regist@${hostName}`}>{`regist@${hostName}`}</a> 宛に
                    空メールを送信してください。
                  </p>
                  <p>
                    <button
                      type="button"
                      className="safety-btn"
                      onClick={() => {
                        window.location.href = `mailto:regist@${hostName}`;
                      }}
                    >
                      {`${siteName}へ登録する`}
                    </button>
                  </p>
                </section>

                <section className="mt20">
                  <h2>
                    {`${siteName}の登録解除`}
                    <img src={iconUnsub} alt="解除アイコン" className="icon-right" />
                  </h2>
                  <p>
                    ボタンをクリックすると、メールソフトが起動します。
                    <br />
                    空メールを送信して登録を解除してください。 詳しくは{kochira}をご覧ください。
                  </p>
                  <p className="txtSmall">
                    メールソフトが起動しない場合やWebメールをご利用の場合は、
                    <br />
                    <a href={`mailto:unsubscribe@${hostName}`}>{`unsubscribe@${hostName}`}</a> 宛に
                    空メールを送信してください。
                  </p>
                  <p>
                    <button
                      type="button"
                      className="safety-btn"
                      onClick={() => {
                        window.location.href = `mailto:unsubscribe@${hostName}`;
                      }}
                    >
                      登録を解除する
                    </button>
                  </p>
                </section>
                <section className="mt20">
                  <h2>
                    過去のメールを確認
                    <img src={iconHistory} alt="履歴アイコン" className="icon-right" />
                  </h2>
                  <p>これまでに配信されたメールを確認できます。</p>
                  <p>
                    <button
                      type="button"
                      className=" safety-btn"
                      onClick={() => {
                        this.onClickBtnMove('../backnumber');
                      }}
                    >
                      過去のメール配信を見る
                    </button>
                  </p>
                </section>
                <section className="mt20">
                  <h2>
                    よくあるご質問
                    <img src={iconFaq} alt="質問アイコン" className="icon-right" />
                  </h2>
                  <p>よくあるご質問をまとめています。 お問い合わせの前にご確認ください。</p>
                  <p>
                    <button
                      type="button"
                      className=" safety-btn"
                      onClick={() => {
                        this.onClickBtnMove('../faq');
                      }}
                    >
                      よくあるご質問集
                    </button>
                  </p>
                </section>
              </div>
            </div>
            <div className="safety-fot">{footer}</div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

SafetyTop.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(SafetyTop);
